import * as React from 'react'
import { Textblock } from './Slices/Textblock';
import { Quote } from './Slices/Quote';
import { Download } from './Slices/Download';
import { Image } from './Slices/Image';
import { getImage } from "gatsby-plugin-image"

export const SliceZone = ({ slices }) => {
	return slices.map((value) => {
		switch (value.slice_type) {
			case 'textblock':
				return <Textblock key={value.id} id={value.id} title={value.primary.title1.text} text={value.primary.text.html} />
			case 'quote':
				return <Quote key={value.id} text={value.primary.quote.html} author={value.primary.author} image={value.primary.image} />
			case 'download':
				return <Download key={value.id} file={value.primary.file.localFile ? value.primary.file.localFile.publicURL : ''} label={value.primary.label} size={value.primary.file.size} extension={value.primary.file.localFile.extension} />
			case 'image':
				if (value.primary.image.localFile?.childImageSharp) {
					const image = getImage(value.primary.image.localFile.childImageSharp);
					return <Image key={value.id} src={image?.images?.fallback?.src} alt={value.primary.image.alt} />
				} else {
					return <Image key={value.id} src={value.primary.image.localFile ? value.primary.image.url : ''}
								  alt={value.primary.image.alt}/>
				}
			default:
				return false
		}
	})
}
